// SPDX-License-Identifier: AGPL-3.0-or-later
// KONVO: Settings no longer manages automations; the Scheduled page does (request box, drafts
// waiting for review, every automation with its runs). Settings > Schedules and automations
// opens that page (UserSettingsModal treats the tab as a link), and the Assistant tab keeps one
// row pointing there.

import {SettingsLinkRow} from '@app/features/app/components/dialogs/shared/SettingsRow';
import {SettingsSection} from '@app/features/app/components/dialogs/shared/SettingsSection';
import {SettingsTabContainer, SettingsTabContent} from '@app/features/app/components/dialogs/shared/SettingsTabLayout';
import Navigation from '@app/features/navigation/state/Navigation';
import {Button} from '@app/features/ui/button/Button';
import * as ModalCommands from '@app/features/ui/commands/ModalCommands';
import {ClockIcon} from '@app/features/ui/icons/Icons';
import {msg} from '@lingui/core/macro';
import {useLingui} from '@lingui/react/macro';

const TITLE = msg({
	message: 'Schedules and automations',
	comment: 'Assistant settings: row that opens the Scheduled page, where automations are managed.',
});
const MOVED = msg({
	message: 'Reminders, scheduled sends, automations and drafts waiting for review are on the Scheduled page.',
	comment: 'Settings: automations moved out of Settings to the Scheduled page.',
});
const OPEN = msg({
	message: 'Open Scheduled',
	comment: 'Settings: button that closes Settings and opens the Scheduled page on its Automations view.',
});

/** Closes Settings and opens the Scheduled page on Automations. */
export function openScheduledAutomations(): void {
	ModalCommands.pop();
	Navigation.navigateToScheduled({filter: 'automations'});
}

/** The Assistant tab's one row where the automations manager used to be. */
export function ScheduledSettingsRow() {
	const {i18n} = useLingui();
	return (
		<SettingsSection id="assistant-flows" title={i18n._(TITLE)}>
			<SettingsLinkRow
				icon={<ClockIcon size={20} />}
				title={i18n._(OPEN)}
				description={i18n._(MOVED)}
				onClick={openScheduledAutomations}
				data-flx="user.konvo-assistant-tab.open-scheduled"
			/>
		</SettingsSection>
	);
}

/** Settings > Schedules and automations, for the moment before it hands over to the page. */
export function ScheduledSettingsTab() {
	const {i18n} = useLingui();
	return (
		<SettingsTabContainer>
			<SettingsTabContent>
				<SettingsSection
					id="assistant-automations-moved"
					linkable={false}
					title={i18n._(TITLE)}
					description={i18n._(MOVED)}
				>
					<div>
						<Button onClick={openScheduledAutomations} data-flx="user.assistant-automations-tab.open-scheduled">
							{i18n._(OPEN)}
						</Button>
					</div>
				</SettingsSection>
			</SettingsTabContent>
		</SettingsTabContainer>
	);
}
